import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const PWAUpdatePrompt = () => {
  const { language } = useLanguage();
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        setRegistration(reg);
        
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                setShowUpdate(true);
              }
            });
          }
        });
      });

      // Listen for controller change
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    }
  }, []);

  const handleUpdate = () => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  };

  if (!showUpdate) return null;

  const texts = {
    fr: {
      title: "Mise à jour disponible",
      update: "Mettre à jour",
    },
    en: {
      title: "Update available",
      update: "Update",
    },
  };

  const t = texts[language];

  return (
    <div 
      className="fixed top-20 left-1/2 -translate-x-1/2 z-50 animate-fade-in"
      role="alert"
    >
      <div className="bg-primary text-primary-foreground rounded-full shadow-lg px-4 py-2 flex items-center gap-3">
        <RefreshCw className="w-4 h-4" />
        <span className="text-sm font-medium">{t.title}</span>
        <Button 
          size="sm" 
          variant="secondary"
          onClick={handleUpdate}
          className="h-7 px-3 text-xs"
        >
          {t.update}
        </Button>
      </div>
    </div>
  );
};

export default PWAUpdatePrompt;
